module.exports = __webpack_public_path__ + "static/media/3DPPA40.9a5f5112.jpg";